import React, { cloneElement, isValidElement, forwardRef, Fragment } from 'react';
const LoopRender = (props, ref) => {
    let { render, data, __designMode } = props;
    if (__designMode === 'design') {
        data = Array.isArray(data) && data.length > 0 ? data : [{ test: 'test' }];
    }
    const list = data?.map((item, index) => {
        if (typeof render === 'function') {
            return render(item, index);
        }
        if (isValidElement(render)) {
            return cloneElement(render, { key: index });
        }
        return render;
    });
    if (__designMode === 'design') {
        return React.createElement("div", { ref: ref },
            " ",
            list);
    }
    return React.createElement(Fragment, null, list);
};
export default forwardRef(LoopRender);
